import { CmpHealthPage } from '../../health/index.js';

export default function HealthPage() {
  return <CmpHealthPage />;
}
